import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import FaqHeroSection from './components/FaqHeroSection';
import FaqAccordionSection from './components/FaqAccordionSection';
import FaqCTASection from './components/FaqCTASection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  url: `${SITE_URL}/faq`,
  mainEntity: [
    {
      '@type': 'Question',
      name: '入会をしたいのですが、年齢制限はありますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '真剣に人生のパートナーをお探しの方でしたら、年齢制限なしでどなたでもご入会いただけます。',
      },
    },
    {
      '@type': 'Question',
      name: '無料相談はどこで行っていますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'オンライン（ZOOM）、LINE電話または都内・近郊地域の方はホテルラウンジなどにて直接お会いして行うことが可能です。所要時間は約60分間を予定しています。',
      },
    },
    {
      '@type': 'Question',
      name: '入会に必要な書類は何を用意すればよいですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '独身証明書または戸籍謄本・抄本（3ヶ月以内）、卒業証明書（短大卒以上）、身分証明書、住民票または光熱費明細（3か月以内）、収入証明書（源泉徴収票等）などが必要です。',
      },
    },
    {
      '@type': 'Question',
      name: '説明を聞いてみたいけど、無理矢理入会させられることはありませんか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '無理な勧誘は行っていません。サービス内容を十分ご理解いただくことを基本としていますので、ご安心してご相談ください。',
      },
    },
    {
      '@type': 'Question',
      name: '婚姻歴と子どもがおります。活動はできますでしょうか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'もちろん、可能です。同様にお子様いらっしゃる方や婚姻歴がある方も多数在籍されています。ご安心ください。',
      },
    },
  ],
};

export default function FaqPage() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活 FAQ | 縁結び 和はは 婚活相談所"
        description="東京のシニア婚活相談所「縁結び和はは」へのよくあるご質問。婚活東京シニア専門で50代・60代・70代の婚活について年齢制限・入会書類・無料相談・婚姻歴の方の活動など東京シニア婚活の疑問にお答え。"
        keywords="東京 シニア 婚活, 婚活相談所 FAQ, シニア婚活よくある質問, 婚活入会東京, 50代婚活質問, 婚活無料相談"
        path="/faq"
        jsonLd={faqJsonLd}
      />
      <Navbar />
      <main>
        <FaqHeroSection />
        <FaqAccordionSection />
        <FaqCTASection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
